import { IItemHistorico } from "../../types";
import { detectarTipoCard } from "./CardRegistry";
import CardHistoricoBase from "./Base/CardHistoricoBase";
import { CirclePlus, CircleX, LucideIcon } from "lucide-react";
import { useState, useCallback } from "react";
import ExpandedContentDemandaCancelada from "./Cards/DemandaCancelada/ExpandedContent";
import LogsVazio from "./Compartilhado/LogsVazio";
import { ExpandedContent, Separator } from "./Cards/DemandaCancelada/styles";

const getIconPadrao = (): { Icon: LucideIcon; color: string } => {
    return { Icon: CirclePlus, color: 'var(--c6b7280)' };
};

const isDemandaCancelada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower === 'Demanda cancelada' || 
           acaoLower.includes('Demanda cancelada') ||
           acaoLower === 'cancelou' ||
           acaoLower.includes('cancelou proposta') ||
           (acaoLower.includes('cancelou') && acaoLower.includes('demanda'));
};

export default function CardHistorico({ item, onNavigateToFile }: { item: IItemHistorico, onNavigateToFile?: (fileId: number) => void }) {
    const [isExpanded, setIsExpanded] = useState(false);
    
    const acaoParaDetectar = item.acao_original || item.acao;
    const cardConfig = detectarTipoCard(acaoParaDetectar);

    const handleToggleExpand = useCallback(() => {
        setIsExpanded((prev) => !prev);
    }, []);

    if (cardConfig) {
        const CardComponent = cardConfig.Component;
        return <CardComponent item={item} onNavigateToFile={onNavigateToFile} isExpanded={isExpanded} onToggleExpand={handleToggleExpand} />;
    }
    
    const icon = getIconPadrao();
    const ehDemandaCancelada = isDemandaCancelada(acaoParaDetectar);
    const temExpansaoDisponivel = true;
    
    const expandedContent = ehDemandaCancelada 
        ? <ExpandedContentDemandaCancelada item={item} onNavigateToFile={onNavigateToFile} />
        : (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    
    return (
        <CardHistoricoBase
            item={item}
            icon={ehDemandaCancelada ? { Icon: CircleX, color: 'var(--c95a5a6)' } : icon}
            temExpansaoDisponivel={temExpansaoDisponivel}
            isExpanded={isExpanded}
            onToggleExpand={handleToggleExpand}
            expandedContent={expandedContent}
        />
    );
}